import React from "react";
import { CSSTransition } from "react-transition-group";
import { isMobile } from "../../../../js/components/searchform/utils/common";

const Callout = props => (
	<CSSTransition in={props.show} unmountOnExit timeout={ isMobile() ? 500 : 800} classNames="newoffers-callout">
		<div
			style={{ ...props.style }}
			className={`newoffers-callout${props.warn
					? " newoffers-callout__warn"
					: props.danger
						? " newoffers-callout__danger"
						: props.success
							? " newoffers-callout__success"
							: props.criticalWarn
								? " newoffers-callout__danger"
								: ""
				}`}
		>
			{!props.hideIcon && (
				<div className="newoffers-callout--icon">
					{props.icon ? (
						<i className={`icon-${props.icon}`} />
					) : (
						<i className={`icon-${props.danger ? "close" : "exclamation"}`} />
					)}
				</div>
			)}
			<div className="newoffers-callout--text">{props.text}</div>
		</div>
	</CSSTransition>
);

export default Callout;
